import './App.css';
import Footer from './components/Footer/Footer';
import Welcome from './pages/welcome/Welcome';
import { Route, useLocation, Switch } from 'react-router-dom';
import Header from './components/Header/Header';
import About from './pages/about/About';
import Projects from './pages/projects/Projects';
import Expertise from './pages/expertise/Expertise';
import Contacts from './pages/contacts/Contacts';
import { Fragment } from 'react';

function App() {
  const location = useLocation();
  return (
    <Fragment>
      <Header />
      <Switch location={location} key={location.pathname}>
        <Route exact path="/" component={Welcome} />
        <Route path="/about" component={About} />
        <Route path="/projects" component={Projects} />
        <Route path="/expertise" component={Expertise} />
        <Route path="/contacts" component={Contacts} />
      </Switch>
      <Footer />
    </Fragment>
  );
}

export default App;
